import {Card, Radio, Typography, List} from "antd";
import {LockOutlined} from "@ant-design/icons";
import React from "react";
import DeviceRadioButtonChecked from "../../assets/svg/DeviceRadioButtonChecked";
import DeviceRadioButtonUnchecked from "../../assets/svg/DeviceRadioButtonUnchecked";
import './index.css'

const {Title, Text} = Typography;

const StyledAccessModeCardItem = ({
                                    checked,
                                    onClick,
                                    title,
                                    icon,
                                    description,
                                    features,
                                    disabled,
                                  }) => (
    <Card
      className={'access-mode-card-item'}
      hoverable
      bordered
      onClick={disabled ? undefined : onClick}
      style={{
        borderColor: checked ? '#DF043A' : '#DCDCDC',
        background: checked ? "#fff" : "#f9f9f9",
        // minHeight: 190,
        height: '100%',
        transition: "border 0.2s, box-shadow 0.2s",
        opacity: disabled ? 0.7 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <div style={{display: "flex", alignItems: "center", marginBottom: 8}}>
        {checked ? <DeviceRadioButtonChecked /> : <DeviceRadioButtonUnchecked />}
        <Title level={3} style={{margin: 0, marginLeft: 8, marginRight: 8, fontSize: 20}}>
          {title}
        </Title>
        {icon}
      </div>
      <Text style={{marginBottom: 10, marginLeft: 30, display: "block", fontSize: 16}} ellipsis>{description}</Text>
      <ul style={{paddingLeft: 54, margin: 0, color: "#888", fontSize: 14}}>
        {features.map((feat, i) => (
          <li key={i}>{feat}</li>
        ))}
      </ul>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '4px',
        height: '100%',
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
        backgroundColor: checked ? '#DF043A' : '#DCDCDC',
      }} />
    </Card>
);

export default StyledAccessModeCardItem;
